export const SEARCH_USER = 'SEARCH_USER'
export const SEARCH_USER_COMPLETE = 'SEARCH_USER_COMPLETE'
export const SEARCH_GET_MEMBER = 'SEARCH_GET_MEMBER'
export const SEARCH_GET_MEMBER_COMPLETE = 'SEARCH_GET_MEMBER_COMPLETE'

export const SHOW_ALL_RESULT = 'SHOW_ALL_RESULT'
export const SHOW_RESULT = 'SHOW_RESULT'
export const RESULT_LOADING = 'RESULT_LOADING'

export const LOAD_RESULT_COMPLETE = 'LOAD_RESULT_COMPLETE'
export const LOAD_HISTORY = 'LOAD_HISTORY'
export const LOAD_HISTORY_COMPLETE = 'LOAD_HISTORY_COMPLETE'

export const LOAD_PRIVILEGE = 'LOAD_PRIVILEGE'
export const LOAD_PRIVILEGE_COMPLETE = 'LOAD_PRIVILEGE_COMPLETE'

export const LOAD_PRIVILEGE_DETAIL = 'LOAD_PRIVILEGE_DETAIL'
export const LOAD_PRIVILEGE_DETAIL_COMPLETE = 'LOAD_PRIVILEGE_DETAIL_COMPLETE'

export const USE_PRIVILEGE = 'USE_PRIVILEGE'
export const USE_PRIVILEGE_ERROR = 'USE_PRIVILEGE_ERROR'
export const USE_PRIVILEGE_COMPLETE = 'USE_PRIVILEGE_COMPLETE'

export const ACTIVATE_CARD = 'ACTIVATE_CARD'
export const ACTIVATE_FAIL = 'ACTIVATE_FAIL'
export const ACTIVATE_ERROR_CLEAR = 'ACTIVATE_ERROR_CLEAR'
export const ACTIVATE_CARD_COMPLETE = 'ACTIVATE_CARD_COMPLETE'

export const USE_PRIVILEGE_DISMISS_ERROR = 'USE_PRIVILEGE_DISMISS_ERROR'
export const USE_PRIVILEGE_EXPIRE = 'USE_PRIVILEGE_EXPIRE'

export const CONFIRM_PRIVILEGE_USE = 'CONFIRM_PRIVILEGE_USE'
export const CONFIRM_PRIVILEGE_USE_FAIL = 'CONFIRM_PRIVILEGE_USE_FAIL'
export const CONFIRM_PRIVILEGE_USE_COMPLETE = 'CONFIRM_PRIVILEGE_USE_COMPLETE'

export default {
  SEARCH_USER,
  SEARCH_USER_COMPLETE,
  SEARCH_GET_MEMBER,
  SEARCH_GET_MEMBER_COMPLETE,
  
  SHOW_ALL_RESULT,
  SHOW_RESULT,
  RESULT_LOADING,
  LOAD_HISTORY,
  LOAD_HISTORY_COMPLETE,
  LOAD_PRIVILEGE,
  LOAD_PRIVILEGE_COMPLETE,
  USE_PRIVILEGE_EXPIRE,
  LOAD_PRIVILEGE_DETAIL,
  LOAD_PRIVILEGE_DETAIL_COMPLETE,
  USE_PRIVILEGE,
  USE_PRIVILEGE_ERROR,
  USE_PRIVILEGE_COMPLETE,
  ACTIVATE_CARD,
  ACTIVATE_FAIL,
  ACTIVATE_ERROR_CLEAR,
  ACTIVATE_CARD_COMPLETE,
  USE_PRIVILEGE_DISMISS_ERROR,

  CONFIRM_PRIVILEGE_USE,
  CONFIRM_PRIVILEGE_USE_FAIL,
  CONFIRM_PRIVILEGE_USE_COMPLETE,
}


// WEBPACK FOOTER //
// ./src/containers/Search/store/actionTypes.js